function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { PureComponent } from "react";
import { StyledDynamicGrid } from "./dynamic-grid-component.scss";
import DefaultProps from "./default-props";
import AssetContentCardComponent from "./components/asset-content-card/asset-content-card-component";
import { withGenericConfig } from "/contexts/generic-config-context";
import { GRID_ITEM_TYPES, DEFAULT_MIN_WIDTH } from "./grid-item-types";
class DynamicGridComponent extends PureComponent {
    get minItemWidth() {
        const { itemMinWidth } = this.props;
        return itemMinWidth || DEFAULT_MIN_WIDTH;
    }
    renderGridItem(child, key) {
        return /*#__PURE__*/ _jsx("div", {
            className: "grid-item",
            children: child
        }, key);
    }
    renderGridItems(gridItems) {
        if (gridItems) {
            const { type } = gridItems;
            switch(type){
                case GRID_ITEM_TYPES.ASSET_CONTENT_CARD:
                    var _gridItems_cards;
                    return (_gridItems_cards = gridItems.cards) === null || _gridItems_cards === void 0 ? void 0 : _gridItems_cards.map((card, index)=>this.renderGridItem(/*#__PURE__*/ _jsx(AssetContentCardComponent, _object_spread({}, card)), index));
                default:
                    return null;
            }
        }
    }
    render() {
        const { gridPadding, horizontalGap, verticalGap, backgroundColor, borderRadius, gridItems, alignToLogo } = this.props;
        return /*#__PURE__*/ _jsx(StyledDynamicGrid, {
            className: "dynamic-grid-component",
            gridPadding: gridPadding,
            horizontalGap: horizontalGap,
            verticalGap: verticalGap,
            backgroundColor: backgroundColor,
            borderRadius: borderRadius,
            minItemWidth: this.minItemWidth,
            alignToLogo: alignToLogo,
            children: gridItems && /*#__PURE__*/ _jsx("div", {
                className: "grid-container",
                children: this.renderGridItems(gridItems)
            })
        });
    }
}
DynamicGridComponent.defaultProps = DefaultProps;
export default withGenericConfig(DynamicGridComponent);
